'use es6';

import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { getAllFeaturesByAllProductLines } from 'pricing-pages-lib/utils/featureUtils';
import { FetchFeaturesRequestTypes } from '../actions/FeatureActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { transformState } from './SelectorUtils';
export const fetchFeaturesStatus = makeRequestStatusSelector(FetchFeaturesRequestTypes.REQUEST);
export const getAllFeaturesByAllProductLinesSelector = createSelectorFromUtil(getAllFeaturesByAllProductLines, transformState);